export default __webpack_public_path__ + "static/color-neutral-palette-light-c52618642373f28dd327bbb8779745ac.png";